import { render, staticRenderFns } from "./AccountSetup.vue?vue&type=template&id=01885928&scoped=true"
import script from "./AccountSetup.vue?vue&type=script&lang=js"
export * from "./AccountSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01885928",
  null
  
)

export default component.exports